export default "/images/terminal.svg?62314645ceb01c471ab4fcc6d5137b5d";